import en from './locales/en.js'
import zh from './locales/zh.js'

export default {
  en,
  zh
}
